import React, { Component } from "react";
import Popup from "react-popup";
import { trackPromise } from "react-promise-tracker";
import {
  formatoSeparadorMilesReturn,
  splitImporte,
  formatoSeparadorMilesValue
} from "../../../generico/utils/FormatoInput";
import CuentaSocioTransferencia from "../../../generico/CuentaSocioTransferencia";
import TransferCuentasPropiasService from "../../../../services/transferencias/TransferCuentasPropiasService";
import {FontAwesomeIcon}  from "@fortawesome/react-fontawesome";
import {faArrowLeft, faArrowRight} from "@fortawesome/free-solid-svg-icons";

//TransferenciaQrEnviarPaso2
export default class TransferenciaQrEnviarPaso2 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
  }

  getInitialState = () => ({
    cuentasOrigen: "",
    monto: 0,
    motivo: "",
    nroOperacion: 0,
    disableSgte: true,
    otrosDesc: "",
    cuentaOrigenSelected: [],
    itemSelected: { value: "-1", label: "--Seleccione--" },
  });
  resetState = () => {
    this.setState(this.getInitialState());
  };
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  componentDidMount() {
    this.getCuentas();
    if (this.props.datosTransfQR.importe !== undefined) {
      let montoInit = formatoSeparadorMilesValue(this.props.datosTransfQR.importe);
      this.setState({ monto: montoInit });
    }
  }

  getCuentas() {
    trackPromise(
      TransferCuentasPropiasService.getCuentas("I").then((response) => {
        if (response.data.codigo !== "0" && response.data.mensaje === "SIN RESULTADOS") {
          Popup.queue(this.notifiPopup("Info", "No posee saldo suficiente en la(s) cuenta(s) de débito para continuar"));
        }
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);
        this.setState({ cuentasOrigen: jsonData.resultadoAH });
      })
    ).catch(function (error) {
      console.log(error);
    });
  }

  selectorValue = (dataFromChild, item) => {
    this.setState(
      {
        cuentaOrigenSelected: dataFromChild,
        cuentaDebito: dataFromChild.cuenta,
        detalleCuenta: dataFromChild.cuenta + " " + dataFromChild.denominacion,
        itemSelected: item,
      },
      this.enableNext
    );
  };

  enableNext(monto, motivo, otrosDesc) {
    if (monto === "") {
      this.setState({ disableSgte: true })
      return;
    }
    if (motivo === "") {
      this.setState({ disableSgte: true })

      return;
    }
    if (motivo === "Otros" && otrosDesc === "") {
      this.setState({ disableSgte: true })
      return
    }

    this.setState({ disableSgte: false })

  }


  render() {
    return (
      <div>
        <form id="idFormPaso2" onSubmit={(e) => e.preventDefault()}>
          <div className="row">
            <div className="steps clearfix">
              <ul role="tablist">
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text current">
                        Leer código QR
                      </span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="current">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Transferencia</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled">
                  <span>
                    <div className="title">
                      <span className="title_text">Datos de Verificación</span>
                    </div>
                  </span>
                </li>
                <li role="tab" className="disabled last">
                  <span>
                    <div className="title">
                      <span className="title_text">Confirmación</span>
                    </div>
                  </span>
                </li>
              </ul>
            </div>
          </div>

          <div className="row justify-content-md-center">
            <div className="col-lg-6 col-md-10">
              <CuentaSocioTransferencia
                selectorValue={this.selectorValue.bind(this)}
                operacion="DEBITO"
                tipoCuenta="AHORRO_VISTA"
                items={this.state.cuentasOrigen}
                itemSelected={this.state.itemSelected}
              />
              <div className="form-group">
                <label className="input-label-bold">Cuenta Destino *</label>
                <input disabled={true} value={this.props.datosTransfQR.numCuentaDestino} type="text" name="cuentaDestino"
                  className="form-control input-box"
                />
              </div>
              <div className="form-group">
                <label className="input-label-bold">Titular de la Cuenta Destino *</label>
                <input disabled={true} value={this.props.datosTransfQR.titularDestinatario} type="text" name="titularCuentaDestino"
                  className="form-control input-box"
                />
              </div>
              <div className="form-group">
                <label className="input-label-bold">Importe a Transferir *</label>
                <input disabled={true} value={this.state.monto} type="text" maxLength="19" name="monto"
                  className="form-control input-box"
                  onChange={(evt) => {
                    var _monto = formatoSeparadorMilesReturn(evt);
                    if (_monto.length > 1 && _monto.substr(0, 1) === "0") {
                      _monto = _monto.substr(1);
                    }
                    this.setState({
                      monto: _monto,
                    });
                    _monto = splitImporte(_monto);
                    this.enableNext(parseFloat(_monto), this.state.motivo, this.state.otrosDesc);
                  }}
                />
              </div>
              <div className="form-group">
                <label className="input-label-bold">
                  Motivo de la Transferencia *
                </label>
                <select
                  value={this.state.motivo}
                  className="form-control input-box"
                  onChange={(evt) => {
                    this.setState({
                      motivo: evt.target.value,
                    });
                    this.enableNext(this.state.monto, evt.target.value, this.state.otrosDesc);
                  }}
                >
                  <option key="-1" value="" disabled>
                    -- Seleccione--
                  </option>
                  <option value="Prestación de Servicios Personales">
                    Prestación de Servicios Personales
                  </option>
                  <option value="Compras de Productos Varios">
                    Compras de Productos Varios
                  </option>
                  <option value="Fondos Familiares">Fondos Familiares</option>
                  <option value="Ayuda Solidaria">Ayuda Solidaria</option>
                  <option value="Otros">Otros</option>
                </select>
              </div>

              <div className="form-group">
                {this.state.motivo === "Otros" && (
                  <textarea
                    rows="4"
                    cols="50"
                    value={this.state.otrosDesc}
                    name="otrosDsc"
                    className="form-control input-box"
                    onChange={(evt) => {
                      this.setState({ otrosDesc: evt.currentTarget.value });
                      this.enableNext(this.state.monto, this.state.motivo, evt.currentTarget.value);
                    }}
                  ></textarea>
                )}
              </div>
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-lg-8 col-md-6">
                <label
                  className="input-label-bold-obligatorio">
                  (*) Campos Obligatorios
                  <br />
                </label>
            </div>
            <div className="col-lg-2 col-md-3">
                <button
                  className="btn btn-cu-quintary btn-consulta"
                  onClick={() => {
                    this.props.previousStep();
                  }}
                >
                <FontAwesomeIcon icon={faArrowLeft} />  Volver
                </button>
                
            </div>
            <div className="col-lg-2 col-md-3">
            <button
                  className="btn btn-cu-primary"
                  disabled={this.state.disableSgte}
                  onClick={() => {
                    var _motivo = (this.state.motivo === "Otros" ? this.state.otrosDesc : this.state.motivo)
                    this.props.returnDataPaso2(this.state.monto, _motivo, this.state.cuentaOrigenSelected);
                      this.nextStep.click();
                  }}
                >
                 Continuar <FontAwesomeIcon icon={faArrowRight} /> 
                </button>
                <button
                  hidden
                  ref={(a) => (this.nextStep = a)}
                  className="btn btn-cu-primary"
                  onClick={this.props.nextStep}
                ></button>
            </div>
          </div>

        </form>
      </div>
    );
  }
}
